import { Component, OnInit, ViewChild, ElementRef, Input, } from '@angular/core';
import * as fileSaver from 'file-saver';
import { CustomgridModel } from '../models/customgrid';
import { Options} from '../models/utilities/utilities.model';
import { BlockTree } from '../models/blocked';
import { DocumentToESigned, ElectronicSignatureModel, ESignataire, ESignaturePosition, GroupeCollaborateur, ParamsESignature, PersonneMorale, SignatureModel } from '../models/signature';
import { CoreService, HttpService } from '../services';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'q-esignature',
  templateUrl: './esignature.component.html',
  styleUrls: ['./esignature.component.css']
})



export class ESignatureComponent  implements OnInit {

  public signatureModel: SignatureModel;

  @Input('idBO') IdBO: string;
  @Input('idDonnee') IdDonnee: string;
  @Input('signMode') SignMode: string;

  public interval: any;
  public statusAdmin: boolean;

  public contactIsVisible: boolean;

  public rootList: Array<BlockTree> = [];

  public selectedNumSignataire: number;

  public signataireCount: number = 0;

  private signaturePositionDrag: ESignaturePosition;

  public showConfig: number = 0;

  public ratioAffichage: number = 1.7;

  public apiIsEnable: boolean;

  public pageHeight: number;
  public pageWidth: number;
  public pageHeightRatio: number;
  public pageWidthRatio: number;
  
  public signatureWidth: number = 250;
  public signatureHeight: number = 50;

  public signatureWidthCalc: number;
  public signatureHeightCalc: number;
  
  public certificats: Options[];

  constructor(    
    protected indParam: CoreService,
    private data: HttpService,
    private modalService: NgbModal,
    ) 
    { }

  ngOnInit(): void {

    this.indParam.showSplash(true);

    //// Type et niveau de certification : simple certified advanced
    this.certificats = [
      { selected: true, text: 'Standard', value: 'simple' },
      { selected:false, text: 'Certifié', value: 'certified' },
      { selected: false, text: 'Avancé', value: 'advanced' }
    ];

    this.signatureModel = new SignatureModel();
    this.signatureModel.eSignatureModel = new ElectronicSignatureModel();
    this.signatureModel.eSignatureModel.documentToESigned = new DocumentToESigned();
    this.signatureModel.eSignatureModel.paramESignature = new ParamsESignature();

    this.statusAdmin = this.indParam.getAutorisation('AdminBO');

    this.contactIsVisible = false;
    
    this.IdBO = this.IdBO === '' ? '0' : this.IdBO;
    this.IdDonnee = this.IdDonnee === '' ? '0' : this.IdDonnee;
    this.SignMode = this.SignMode !== 'SCELLER' && this.SignMode !== 'SIGNER' ? 'ALL' : this.SignMode;
    
    // Recuperation de la configuration 
    this.data.getHttp<SignatureModel>(`${this.indParam.AppParams.apiUrl}api/signature/GET_JSE_SIGNATURE_CONFIG/0`).subscribe(
      (result: SignatureModel) => {
        // Configuration des signatures autorises
        this.signatureModel.eSignatureModel.heightDoc = result.eSignatureModel.heightDoc;
        this.signatureModel.eSignatureModel.widthDoc = result.eSignatureModel.widthDoc;
        this.signatureModel.eSignatureModel.apiNameSignature = result.eSignatureModel.apiNameSignature;
        this.signatureModel.eSignatureModel.lstSignataires = result.eSignatureModel.lstSignataires;
        this.signatureModel.eSignatureModel.paramESignature = result.eSignatureModel.paramESignature;

        // Page du document
        this.pageHeight = parent.innerHeight * 0.7;
        this.pageWidth = parent.innerHeight * 0.7 * 0.69;

        // Ratio 
        this.pageHeightRatio = this.pageHeight / this.signatureModel.eSignatureModel.paramESignature.heightDoc;
        this.pageWidthRatio = this.pageWidth / this.signatureModel.eSignatureModel.paramESignature.widthDoc;

        // Position des signatures
        result.eSignatureModel.paramESignature.eSignaturePositions.forEach((position: ESignaturePosition) => {
          position.posXcalc = position.posXcalc * this.pageWidthRatio;
          position.posYcalc = position.posYcalc * this.pageHeightRatio;
        });

        // Position de la signature de scellement
        result.eSignatureModel.paramESignature.eScellementSignaturePositions.forEach((position: ESignaturePosition) => {
          position.posXcalc = position.posXcalc * this.pageWidthRatio;
          position.posYcalc = position.posYcalc * this.pageHeightRatio;
        });

        // Cadre de la signature
        this.signatureWidthCalc = this.signatureWidth * this.pageWidthRatio;
        this.signatureHeightCalc = this.signatureHeight * this.pageHeightRatio;


        //const apiIsConfigured: boolean = (this.signatureModel.eSignatureModel.paramESignature.host !== '' && this.signatureModel.eSignatureModel.paramESignature.shortcut !== '' && this.signatureModel.eSignatureModel.paramESignature.isSecret);       
        this.showConfig = this.SignMode === 'SCELLER' ? 3 : this.SignMode === 'SIGNER' || this.SignMode === 'ALL' ? 2 : this.statusAdmin ? 1 : 0; //!apiIsConfigured ? 1 : 2;
        this.apiIsEnable = this.signatureModel.eSignatureModel.apiNameSignature !== null && this.signatureModel.eSignatureModel.apiNameSignature !== '';

        // Liste des collaborateurs
        this.data.getHttp<SignatureModel>(`${this.indParam.AppParams.apiUrl}api/signature/GET_COLLABORATEURS/${this.IdDonnee}`).subscribe(
          (result: SignatureModel) => {
            this.signatureModel.eSignatureModel.lstGroupeCollaborateurs = result.eSignatureModel.lstGroupeCollaborateurs;
          });

        // Liste des contacts du client lié au document
        this.data.getHttp<SignatureModel>(`${this.indParam.AppParams.apiUrl}api/signature/GET_CONTACTS/${this.IdDonnee}`).subscribe(
          (result: SignatureModel) => {
            this.signatureModel.eSignatureModel.lstClients = result.eSignatureModel.lstClients;
          });

        if (this.apiIsEnable) {

          // Info du token office et status du token utilisateur
          this.getTokenStatus();

          // Etat de transaction du document        
          this.data.getHttp<SignatureModel>(`${this.indParam.AppParams.apiUrl}api/signature/GET_JSE_TRANSACTION_STATUS/${this.IdDonnee}`).subscribe(
            (result: SignatureModel) => {
              this.signatureModel.eSignatureModel.strEtatTransaction = result.eSignatureModel.strEtatTransaction;
              this.signatureModel.eSignatureModel.strIdTransaction = result.eSignatureModel.strIdTransaction;
              this.signatureModel.eSignatureModel.strIdDocument = result.eSignatureModel.strIdDocument;
              this.signatureModel.eSignatureModel.documentToESigned = result.eSignatureModel.documentToESigned;
            });
        }
        this.indParam.showSplash(false);
      });
  }


  public getTokenStatus(): void {

    // Info du token office et status du token utilisateur
    this.data.getHttp<SignatureModel>(`${this.indParam.AppParams.apiUrl}api/signature/GET_JSE_TOKEN_STATUS/0`).subscribe(
      (result: SignatureModel) => {
        this.signatureModel.eSignatureModel.strInfoTokenOffice = result.eSignatureModel.strInfoTokenOffice;
        this.signatureModel.eSignatureModel.isTokenUserExpired = result.eSignatureModel.isTokenUserExpired;
        if (this.interval && !result.eSignatureModel.isTokenUserExpired)
          clearInterval(this.interval);
      });

  }

  // Connection au partail et recuperation des tokens bureau et utilisateur
  public refreshToken(): void {

    this.data.getHttp<SignatureModel>(`${this.indParam.AppParams.apiUrl}api/signature/GET_JSE_TOKEN/OFFICEUSER`).subscribe(
      (result: SignatureModel) => {
        this.signatureModel.eSignatureModel.strTokenURL = result.eSignatureModel.strTokenURL;
        window.open(this.signatureModel.eSignatureModel.strTokenURL, '_blank', '');
        this.interval = setInterval(() => { this.getTokenStatus(); }, 3000);
      });
  }

  // Signer le document
  public signerDocument(): void {
    this.indParam.showSplash(true);
    this.signatureModel.Mode = 'POST_JSE_SIGNATURE';
    this.signatureModel.eSignatureModel.strIdDocument = this.IdDonnee;
    this.data.postHttp<SignatureModel>(`${this.indParam.AppParams.apiUrl}api/signature/`, this.signatureModel).subscribe(
      (result: SignatureModel) => {
        this.signatureModel.eSignatureModel.strIdTransaction = result.eSignatureModel.strIdTransaction;
        // Etat de transaction du document        
        this.data.getHttp<SignatureModel>(`${this.indParam.AppParams.apiUrl}api/signature/GET_JSE_TRANSACTION_STATUS/${this.IdDonnee}`).subscribe(
          (result: SignatureModel) => {
            this.signatureModel.eSignatureModel.strEtatTransaction = result.eSignatureModel.strEtatTransaction;
            this.signatureModel.eSignatureModel.documentToESigned = result.eSignatureModel.documentToESigned;
            this.indParam.showSplash(false);
          });
      });
  }

  // Sceller le document
  public scellerDocument(): void {
    this.indParam.showSplash(true);
    this.signatureModel.Mode = 'POST_JSE_SCELLEMENT';
    this.signatureModel.eSignatureModel.strIdDocument = this.IdDonnee;
    this.data.postHttp<SignatureModel>(`${this.indParam.AppParams.apiUrl}api/signature/`, this.signatureModel).subscribe(
      (result: SignatureModel) => {
        this.signatureModel.eSignatureModel.strIdTransaction = result.eSignatureModel.strIdTransaction;
        this.indParam.showSplash(false);
      });
  }

  // Telecharger le document
  public telechargerDocument(): void {
    this.indParam.showSplash(true);
    this.data.getHttp<SignatureModel>(`${this.indParam.AppParams.apiUrl}api/signature/GET_JSE_ELECTRONICSIGNEDDOC/${this.IdDonnee}`).subscribe(
      (result: SignatureModel) => {

        const customgridModel: CustomgridModel = new CustomgridModel();
        customgridModel.FileModel.Ident = this.IdDonnee;
        customgridModel.cgParameters.Mode = 'GETINFODOWNLOAD';
        this.data.postHttp<CustomgridModel>(`${this.indParam.AppParams.apiUrl}api/customgrid`, customgridModel).subscribe((data: CustomgridModel) => {
          customgridModel.FileModel = data.FileModel;
          customgridModel.FileModel.DownloadMode = 'OPENFILE';

          this.data.download(`${this.indParam.AppParams.apiUrl}api/Download`, customgridModel.FileModel).subscribe((response: any) => {
            if (response) {              
              const blob: Blob = new Blob([(response)], {
                type: 'application/pdf',
              });

              if (blob.size > 0) {
                
                //this.showFile(blob, this.IdDonnee);
                fileSaver.saveAs(blob, `${this.IdDonnee}.pdf`);
              }

            }
          });

        });
        this.signatureModel.eSignatureModel.documentToESigned.lectureSeule = true;
        this.indParam.showSplash(false);
      });
  }

 

  public showFile(blobData: Blob, reportName: string) : void {
    // Adapted from: https://blog.jayway.com/2017/07/13/open-pdf-downloaded-api-javascript/
    const newBlob = new Blob([blobData], { type: "application/pdf" });

    const newWindow = window.open('', reportName, "width=600,height=900");
    if (newWindow !== null) {
      setTimeout(() => {
        const dataUrl = window.URL.createObjectURL(newBlob);
        const title = newWindow.document.createElement('title');
        const iframe = newWindow.document.createElement('iframe');
        
        title.appendChild(document.createTextNode(reportName));
        newWindow.document.head.appendChild(title);

        iframe.setAttribute('src', dataUrl);
        iframe.setAttribute('width', "100%");
        iframe.setAttribute('height', "100%");

        newWindow.document.body.appendChild(iframe);

        setTimeout(() => {
          // For Firefox it is necessary to delay revoking the ObjectURL
          window.URL.revokeObjectURL(dataUrl);
        }, 100);
      }, 100);
    } else {
      alert("To display reports, please disable any pop-blockers for this page and try again.");
    }

  };

  // Gestion des collaborateurs
  //  @description open and close the users drop down
  //  @param {GroupeCollaborateur} office block containing users
  //  @param {any} event concerned event
  //  @return {void}
  public showUsers(office: GroupeCollaborateur, event: any): void {
    event.preventDefault();
    office.collapseMode = office.collapseMode === 1 ? 2 : 1;
    for (let n: number = 0; n < this.signatureModel.eSignatureModel.lstGroupeCollaborateurs.length; n++) {
      if (this.signatureModel.eSignatureModel.lstGroupeCollaborateurs[n].id !== office.id)
        this.signatureModel.eSignatureModel.lstGroupeCollaborateurs[n].collapseMode = 1;
    }
    
  }

  // Affiche les contacts du client
  public showContacts(event: any): void {
    event.preventDefault();
    this.contactIsVisible = this.contactIsVisible ? false : true;
  }

  // Gestion des dirigeants
  public updateSignataires(user: ESignataire): void {
    if (this.selectedNumSignataire) {
      
      var ppFinded = this.signatureModel.eSignatureModel.lstSignataires.find((pp: ESignataire) => pp.position.numero == this.selectedNumSignataire);
      if (ppFinded) {
        this.delSignataire(ppFinded);

        user.isChecked = true;

        // Collaborateur
        this.signatureModel.eSignatureModel.lstGroupeCollaborateurs.forEach((group: GroupeCollaborateur) => {
          var ppFinded = group.lstCollaborateurs.find((pp: ESignataire) => pp.id == user.id);
          if (ppFinded) {
            ppFinded.isChecked = true;            
          }
        });

        ppFinded.id = user.id;
        ppFinded.value = user.value;
        ppFinded.email = user.email;
        ppFinded.phone = user.phone;
        ppFinded.isChecked = user.isChecked;
        this.selectedNumSignataire = 0;
        this.signataireCount = this.signataireCount + 1;
      }
    }
  }

  // Popup d'ajout d'un signataire
  public addSignataire(user: ESignataire): void {
    this.selectedNumSignataire = user.position.numero; 
  }
  
  public delSignataire(user: ESignataire): void {
    let finded: boolean = false;
    // Collaborateur
    this.signatureModel.eSignatureModel.lstGroupeCollaborateurs.forEach((group: GroupeCollaborateur) => {
      var ppFinded = group.lstCollaborateurs.find((pp: ESignataire) => pp.id == user.id);
      if (ppFinded) {
        ppFinded.isChecked = false;
        finded = true;
      }
    });
  
    // Client : dirigeant ou contact
      this.signatureModel.eSignatureModel.lstClients.forEach((client: PersonneMorale) => {
        // Dirigeant
        var ppFinded = client.lstDirigeants.find((pp: ESignataire) => pp.id == user.id);
        if (ppFinded) {
          ppFinded.isChecked = false;
          finded = true;
        }
        // Contact
        var ppFinded = client.lstContacts.find((pp: ESignataire) => pp.id == user.id);
        if (ppFinded) {
          ppFinded.isChecked = false;
          finded = true;
        }
      });

    if (finded)
      this.signataireCount = this.signataireCount - 1;

    user.id = '';
    user.value = user.position.info;
    user.isChecked = false;
    
  }

  // Popup de configuration de l'api

  public getSignatureCertificat(e: any): void {
    this.signatureModel.eSignatureModel.paramESignature.certificat = e.target.value;
  }

  public saveConfigSignature(): void {
    this.indParam.showSplash(true);
    // Position des signatures
    this.signatureModel.eSignatureModel.paramESignature.eSignaturePositions.forEach((position: ESignaturePosition) => {
      position.posXcalc = position.posXcalc / this.pageWidthRatio;
      position.posYcalc = position.posYcalc / this.pageHeightRatio;
    });
    // Position de la signature de scellement
    this.signatureModel.eSignatureModel.paramESignature.eScellementSignaturePositions.forEach((position: ESignaturePosition) => {
      position.posXcalc = position.posXcalc / this.pageWidthRatio;
      position.posYcalc = position.posYcalc / this.pageHeightRatio;
    });

    this.signatureModel.Mode = 'SAVE_PARAMSESIGNATURE';    
    this.data.postHttp<SignatureModel>(`${this.indParam.AppParams.apiUrl}api/signature/`, this.signatureModel).subscribe(
      (result: SignatureModel) => {
        // Raz des personnes physiques selectionné
        // Collaborateur
        this.signatureModel.eSignatureModel.lstGroupeCollaborateurs.forEach((group: GroupeCollaborateur) => {
          group.lstCollaborateurs.forEach((pp: ESignataire) => { pp.isChecked = false; });
        });
        // Client : dirigeant ou contact
        this.signatureModel.eSignatureModel.lstClients.forEach((client: PersonneMorale) => {
          // Dirigeant
          client.lstDirigeants.forEach((pp: ESignataire) => { pp.isChecked = false; });
          // Contact
          client.lstContacts.forEach((pp: ESignataire) => { pp.isChecked = false; });          
        });

        this.signatureModel.eSignatureModel.heightDoc = result.eSignatureModel.heightDoc;
        this.signatureModel.eSignatureModel.widthDoc = result.eSignatureModel.widthDoc;
        this.signatureModel.eSignatureModel.lstSignataires = result.eSignatureModel.lstSignataires;
        this.signatureModel.eSignatureModel.paramESignature = result.eSignatureModel.paramESignature;
        // Position des signatures
        this.signatureModel.eSignatureModel.paramESignature.eSignaturePositions.forEach((position: ESignaturePosition) => {
          position.posXcalc = position.posXcalc * this.pageWidthRatio;
          position.posYcalc = position.posYcalc * this.pageHeightRatio;
        });
        // Position de la signature de scellement
        this.signatureModel.eSignatureModel.paramESignature.eScellementSignaturePositions.forEach((position: ESignaturePosition) => {
          position.posXcalc = position.posXcalc * this.pageWidthRatio;
          position.posYcalc = position.posYcalc * this.pageHeightRatio;
        });

        this.indParam.showSplash(false);
      });
  }

  public closeConfigSignature(): void { }


  public open(content:any) {
    this.modalService.open(content, { size: 'xl', centered: true, windowClass: 'qmodalover'  }).result.then((result) => {
      switch (result) {
        case 'SAVE': this.saveConfigSignature(); break;
        case 'CANCEL': this.closeConfigSignature();break;
      }     
    });
  }


  public hideshowSignataire(signPosition: ESignaturePosition): void {
    signPosition.isVisible = signPosition.isVisible ? false : true;
  }

  public showConfiguration(): void {
    this.showConfig =  1;
  }

  public showSignature(): void {
    this.showConfig =  2;
  }

  public showScellement(): void {
    this.showConfig = 3;
  }


  public allowDrop(event: any) {
    event.preventDefault();
  }

  public onDrop(event: any) {
    this.signaturePositionDrag.posX = Math.round(this.signaturePositionDrag.posX + (event.clientX - event.dataTransfer.getData('Xrel')) / this.pageWidthRatio);
    if (this.signaturePositionDrag.posX < 0) this.signaturePositionDrag.posX = 0;
    if (this.signaturePositionDrag.posX > this.signatureModel.eSignatureModel.paramESignature.widthDoc - this.signatureWidth) this.signaturePositionDrag.posX = this.signatureModel.eSignatureModel.paramESignature.widthDoc - this.signatureWidth;
    this.signaturePositionDrag.posY = Math.round(this.signaturePositionDrag.posY - (event.clientY - event.dataTransfer.getData('Yrel')) / this.pageWidthRatio);
    if (this.signaturePositionDrag.posY < 0) this.signaturePositionDrag.posY = 0;
    if (this.signaturePositionDrag.posY > this.signatureModel.eSignatureModel.paramESignature.heightDoc - 50) this.signaturePositionDrag.posY = this.signatureModel.eSignatureModel.paramESignature.heightDoc - 50;

    this.signaturePositionDrag.posXcalc = this.signaturePositionDrag.posXcalc + (event.clientX - event.dataTransfer.getData('Xrel'));
    if (this.signaturePositionDrag.posXcalc < 0) this.signaturePositionDrag.posXcalc = 0;
    if (this.signaturePositionDrag.posXcalc > this.pageWidth - this.signatureWidthCalc) this.signaturePositionDrag.posXcalc = this.pageWidth - this.signatureWidthCalc;
    this.signaturePositionDrag.posYcalc = this.signaturePositionDrag.posYcalc + (event.clientY - event.dataTransfer.getData('Yrel'));
    if (this.signaturePositionDrag.posYcalc < 0) this.signaturePositionDrag.posYcalc = 0;
    if (this.signaturePositionDrag.posYcalc > this.pageHeight - this.signatureHeightCalc) this.signaturePositionDrag.posYcalc = this.pageHeight - this.signatureHeightCalc;
  }

  public onDrag(event: any, signPosition: ESignaturePosition) {
    this.signaturePositionDrag = signPosition;
    event.dataTransfer.setData('Xrel', event.clientX);
    event.dataTransfer.setData('Yrel', event.clientY);
  }

  public setNewPosition(eSignature: ESignaturePosition) {    
    eSignature.posX = eSignature.posX > 335 ? 335 : eSignature.posX < 0 ? 0 : eSignature.posX;
    eSignature.posY = eSignature.posY > 792 ? 792 : eSignature.posY < 0 ? 0 : eSignature.posY;

    eSignature.posXcalc = eSignature.posX * this.pageWidthRatio;
    eSignature.posYcalc = (this.signatureModel.eSignatureModel.paramESignature.heightDoc - 50 - eSignature.posY) * this.pageHeightRatio;    
  }

  public blinkSignature(eSignature: ESignaturePosition) {
    eSignature.blink = true;
    setTimeout(function () { eSignature.blink = false; }.bind(this), 300)
    eSignature.blink = true;
    setTimeout(function () { eSignature.blink = false; }.bind(this), 300)
  }

}


